import * as RadTooltip from '@radix-ui/react-tooltip';
export * from './tooltip';
export const TooltipProvider = RadTooltip.Provider;
//# sourceMappingURL=index.js.map